// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXfmzubXvoXEsRNXXpE2yEZiQBSU2QieY",
  authDomain: "chat-app-5ee5d.firebaseapp.com",
  projectId: "chat-app-5ee5d",
  storageBucket: "chat-app-5ee5d.appspot.com",
  messagingSenderId: "618296720051",
  appId: "1:618296720051:web:560ba17f77585d50e14ec6"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();